require('./stylesheets/_registration.scss');


angular.module('pages.registration', [])
	.config(config);

config.$inject = ['$stateProvider'];
function config($stateProvider) {
	$stateProvider
		.state('pages.registration', {
			url: 'registration',
			template: require('./templates/index.html'),
			controller: require('./controllers/registration'),
			data: {
				// restricted: true
				iframe: false
			},
			pageTrack: '/registration'
		})
}

module.exports = 'pages.registration';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/registration/index.js
 ** module id = 287
 ** module chunks = 1
 **/